import React, {ReactNode} from "react";
import {Button} from "primereact/button";
import AdminDialogType from "../AdminDialogType";
import {
	OAuth,
	OAuthProvider, OAuthProviderFlow,
	OAuthProviderInterface, OAuthProviderName, OAuthProviders
} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import Translate from "../../../shared/translation/Translate";
import {Accordion} from "primereact/accordion";
import {Dropdown} from "primereact/dropdown";
import DomHelper from "../../../shared/helper/DomHelper";
import OAuthDialog, {OAuthDialogProperties} from "./OAuthDialog";
import Helper from "../../../shared/components/Helper";
import FunctionHelper from "../../../shared/helper/FunctionHelper";

export class OAuthPortalDialogDefinition extends OAuthDialog {
	protected renderContents(): ReactNode {
		let parameter: OAuth | undefined = this.state.parameter;
		let azureSet: boolean = false;
		let auth0Set: boolean = false;
		let providerElements: Array<ReactNode> = [];
		for (let provider of FunctionHelper.applyValue(
			parameter?.providers?.provider, OAuthProviders.getProviderDefault()
		)) {
			if (provider.flow !== OAuthProviderFlow.AuthorizationCodeWithPkce) {
				continue;
			}

			if (provider.name === OAuthProviderName.AzureAd) {
				azureSet = true;
			}

			if (provider.name === OAuthProviderName.Auth0) {
				auth0Set = true;
			}

			providerElements.push(this.renderProvider(provider, providerElements.length, {logout: true}));
		}

		return (
			<>
				<Helper {...this.props}>
					<Translate {...this.props} data={"dialog.admin.oauth.portal"} namespace={"help"} markdown={true}/>
				</Helper>
				<fieldset className="p-col-12 p-grid">
					<div className="p-col-12 p-grid">
						<div className="p-col-12">
							{providerElements.length === 0 ?
								<p className="no-results">
									<Translate {...this.props} data="oauth.empty" namespace="dialog"/>
								</p> :
								<Accordion>
									{providerElements}
								</Accordion>
							}
						</div>
						<hr/>
						<div className="p-col-12 p-sm-4">
							<Dropdown inputId="control-add-type" value={this.state.type}
									  options={[
										  {
											  label: Translate.value("oauth.type.generic", {ns: "dialog"}),
											  value: OAuthProviderName.Generic
										  },
										  {
											  label: Translate.value("oauth.type.azuread", {ns: "dialog"}),
											  value: OAuthProviderName.AzureAd,
											  disabled: azureSet
										  },
										  {
											  label: Translate.value("oauth.type.auth0", {ns: "dialog"}),
											  value: OAuthProviderName.Auth0,
											  disabled: auth0Set
										  }
									  ]}
									  onChange={(e) => this.setState({
										  type: e.value
									  })}
									  appendTo={document.getElementById("root")}/>
						</div>
						<div className="p-col-12 p-sm-4">
							<Button label={Translate.value("buttons.add")} icon="icon icon-add"
									className="dialog-button"
									onClick={() => {
										let addParameter: OAuthProvider;
										switch (this.state.type) {
											case OAuthProviderName.Generic:
												addParameter = new OAuthProvider({
													name: this.state.type,
													flow: OAuthProviderFlow.AuthorizationCodeWithPkce,
													id: this.state.type + OAuthProviderFlow.AuthorizationCodeWithPkce +
														DomHelper.generateUUID(true),
												} as OAuthProviderInterface);
												break;
											case OAuthProviderName.AzureAd:
												addParameter = new OAuthProvider({
													name: this.state.type,
													flow: OAuthProviderFlow.AuthorizationCodeWithPkce,
													id: this.state.type + OAuthProviderFlow.AuthorizationCodeWithPkce +
														DomHelper.generateUUID(true),
													displayName: "Microsoft",
													discoveryUrl: "https://login.microsoftonline.com/{tenantId}/v2.0/.well-known/openid-configuration",
													claimSessionId: "sub",
													claimClientId: "azp",
													claimRoles: "scp",
													roleNameAdmin: "Edit",
													roleNameUser: "Read",
													scope: "offline_access openid",
													logout: {
														url: "https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri={redirectUrl}"
													}
												} as OAuthProviderInterface);
												break;
											case OAuthProviderName.Auth0:
												addParameter = new OAuthProvider({
													name: this.state.type,
													flow: OAuthProviderFlow.AuthorizationCodeWithPkce,
													id: this.state.type + OAuthProviderFlow.AuthorizationCodeWithPkce +
														DomHelper.generateUUID(true),
													displayName: "Auth0",
													claimSessionId: "sub",
													claimClientId: "azp",
													claimRoles: "permissions",
													roleNameAdmin: "admin",
													roleNameUser: "user",
													scope: "offline_access openid profile email",
													logout: {
														url: "https://softvision.eu.auth0.com/v2/logout?returnTo={redirectUrl}&amp;client_id={clientId}"
													}
												} as OAuthProviderInterface);
												break;
										}

										this.setState({
											type: OAuthProviderName.Generic,
											showAddDialog: true,
											addParameter: addParameter
										});
									}}/>
						</div>
					</div>
				</fieldset>
			</>
		);
	}

	protected getDialogType(): AdminDialogType {
		return AdminDialogType.OAUTH_PORTAL;
	}
}

const OAuthPortalDialog = React.memo(OAuthPortalDialogDefinition,
	(prevProps: Readonly<OAuthDialogProperties>, nextProps: Readonly<OAuthDialogProperties>) => {
		if (!nextProps.visible && !prevProps.visible) {
			return true
		}

		return false;
	}
);

export default OAuthPortalDialog;